module.exports = __webpack_public_path__ + "static/media/Mascot_vic_ai.cf54326e.zip";